import React, { Component } from 'react';
import PropTypes from 'prop-types';


class ArrowFormElement extends Component {
  render() {
    const sort = this.props.sort;

    return this.props.show ? (
      <img onClick={this.props.onClick}
           src={`/misc/arrow-${sort}.png`}
           alt="sortBy icon"
           title={`sortBy ${sort}ending`}
           width="13" height="13" />
    ) : null;
  }
}

ArrowFormElement.defaultProps = {
  // alternative "desc"
  sort: 'asc',
  show: false,
  onClick: () => {
  },
};

ArrowFormElement.propTypes = {
  sort: PropTypes.string,
  onClick: PropTypes.func,
  show: PropTypes.bool,
};


export default ArrowFormElement;



// WEBPACK FOOTER //
// ./src/components/search/FormElements/ArrowFormElement/ArrowFormElement.js